class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;

    /* Safety net: if the gate hasn't released yet (header-ready flag is off)
       and the details was somehow opened, slam it shut immediately. The CSS
       + capture-phase click gate in header.liquid should prevent this from
       reaching us, but toggle can also be triggered by programmatic `.open`
       assignment or untrusted events that bypass the click listener. */
    if (this.mainDetailsToggle.hasAttribute('open') &&
        document.documentElement.getAttribute('data-header-ready') !== 'true') {
      this.mainDetailsToggle.removeAttribute('open');
      return;
    }

    this.header.preventHide = this.mainDetailsToggle.open;

    /* Re-measure every toggle and validate: if the first toggle happens before
       layout settles (slow networks / cold loads), bounding-rect can return a
       value larger than the viewport, which cascades into a negative max-height
       on .mega-menu__content and collapses the megamenu until a full reload. */
    const bottom = Math.floor(this.header.getBoundingClientRect().bottom);
    if (bottom > 0 && bottom < window.innerHeight) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${bottom}px`
      );
    }
  }
}

customElements.define('header-menu', HeaderMenu);
